// Chat answers only as a named agent, so a link, QR code or embed snippet with
// no agent behind it could only ever fail for whoever scans or pastes it.
export const NO_AGENT_LINK_MESSAGE = 'This agent has no ID yet, so no link or QR code can be made.';

export const hasAgentId = (agent) => Boolean(String(agent?.id ?? '').trim());

// The address to share for an agent, or null when there is no agent to point at.
export const agentPublicUrl = (agent) => {
  if (!hasAgentId(agent)) return null;
  const slug = (agent.slug || '').trim();
  // Never guess a public URL from a mutable display name: without a slug, link
  // the ID-based chat page.
  return slug
    ? `${window.location.origin}/${encodeURIComponent(slug)}`
    : `${window.location.origin}/chat.html?agent=${encodeURIComponent(agent.id)}`;
};
